import React from "react";
import { MultiSelect } from "react-multi-select-component";

const WebmailInbox = ({ mailboxes = [], selectedMailboxIds = [], onChange, loading }) => {
    const options = mailboxes.map((mailbox) => ({
        label: mailbox.name || mailbox.email,
        value: mailbox.id || mailbox._id,
    }));

    return (
        <div className="drop-header">
            <MultiSelect
                className="gmail-scroll"
                options={options}
                value={selectedMailboxIds}
                onChange={onChange}
                labelledBy="Select Webmail Accounts"
                disabled={loading || options.length === 0}
            />
        </div>
    );
};

export default WebmailInbox;
